export const getAuthToken = () => {
  const authToken = sessionStorage.getItem("authInfo");
  return authToken;
};
